import React from 'react';

const Checkbox = ({ width = '14', height = '14', className, ...rest }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="checkbox icon"
      {...rest}
    >
      <path
        d="M10.6667 0H1.33333C0.593333 0 0 0.593333 0 1.33333V10.6667C0 11.0203 0.140476 11.3594 0.390524 11.6095C0.640573 11.8595 0.979711 12 1.33333 12H10.6667C11.0203 12 11.3594 11.8595 11.6095 11.6095C11.8595 11.3594 12 11.0203 12 10.6667V1.33333C12 0.593333 11.4 0 10.6667 0ZM10.6667 1.33333V10.6667H1.33333V1.33333H10.6667Z"
        fill="#999999"
      />
    </svg>
  );
};

export { Checkbox };
